import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";

import {
  COMMON_SERVICES,
  headersConfigData,
} from "redux/reduxToolkitServices/_commonServices/commonServices";
import moment from "moment";
import "@progress/kendo-theme-default/dist/all.css";
import { useHookstate } from "@hookstate/core";
import { Box } from "@mui/system";
import { PopUpContainer } from "assets/css/globle";

import {
  FLEET_GLOBAL_STATES,
  MESSAGE_FLEET_GLOBAL_STATES,
  UPDATED_CAR_DATA_STATE
} from "globalStore/globalStore";
import { SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import { API_CALLS } from "./../../../redux/reduxToolkitServices/_commonApiCalls/api";
import {
  Chart,
  ChartSeries,
  ChartArea,
  ChartTooltip,
  ChartSeriesItem,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartTitle,
  ChartValueAxis,
  ChartValueAxisItem,
  ChartLegend,
  ChartSeriesDefaults,
} from "@progress/kendo-react-charts";
import "hammerjs";
import { CarDetails } from "commonComponents/CarDetails";
import { Checkbox, Modal } from "@mui/material";
import { CircleBtn } from "assets/css/globle";
import {
  UsageContainer,
  ChartRow,
  Wrapper,
  SortingHeader,
  ChartTooltipSection
} from "pages/Fleet/Usage/UsageStyled";
import { Loader } from "commonComponents/Loader/Loader";
import { API_STATUSES } from "redux/_helpers/statuses";

import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { MsgToSelectedCarsCmp } from "commonComponents/SideNav/subSectionNav/Map/commonFunctionalities/MsgToSelectedCars";
import { useTranslation } from "react-i18next";
import FormControlLabel from "@mui/material/FormControlLabel";
import UnCheckIcon from "assets/svgIcons/UncheckIcon";
import Tooltip from "@mui/material/Tooltip";
import CheckIcon from "assets/svgIcons/CheckIcon";
import { getFeatureSetOption, isUserAdmin, isUserSupport, getFeaturesList } from "constant";
import { getUserRole } from "redux/reduxToolkitServices/_commonReducers/commonReducers";
import { AmpHoursChart } from "commonComponents/Charts/AmpHoursChart";
import TodayDateActionBar from "commonComponents/Calendar/todayDateActionBar";

const UsageReport = React.memo(() => {
  const formatRangeValue = (value) => {
    if (value === null || value === undefined || value === "" || isNaN(value)) return "";
    return Number(Number(value).toFixed(3)).toString();
  };
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { roundStateGlobal, holeStateGlobal, gpsCardIdStateData } = useHookstate(FLEET_GLOBAL_STATES);
  const { updatedCarData } = useHookstate(UPDATED_CAR_DATA_STATE);
  const { setMsgToSingleCar } = useHookstate(FLEET_GLOBAL_STATES);

  const [odometerZeroFilter, setOdometerZeroFilter] = useState(true);
  const [WattPerMilesZeroFilter, setWattPerMilesZeroFilter] = useState(true);
  const [KWHoursZeroFilter, setKWHoursZeroFilter] = useState(true);
  const [AmpHoursZeroFilter, setAmpHoursZeroFilter] = useState(true);
  const [AHPerMilesZeroFilter, setAHPerMilesZeroFilter] = useState(true);
  const [domRender, setDomRender] = useState(false);
  const [TempCarObj, setTempCarObj] = useState(null);
  const [getRoundsByCarTempDetailState, setRoundsByCarTempDetailState] = useState(null);
  const [startDate, setStartDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment(new Date()).format("YYYY-MM-DD"));

  const [open, setOpen] = useState(false);
  const [MtdState, setMtdState] = useState(false);
  const [openCarNotFound, setOpenCarNotFound] = React.useState(false);
  const [clickedCarNumber, setClickedCarNumber] = React.useState(false);
  const [QtdState, setQtdState] = useState(false);
  const [YTDState, setYTDState] = useState(false);
  // Cross-graph tooltip sync: keeps the underlying Kendo chart instance of
  // every Usage graph so a hover on one chart can open the native tooltip on
  // all the others.
  const chartInstancesRef = useRef({});
  // Scrolling container, used to tell whether a chart is actually on screen.
  const usageContainerRef = useRef(null);
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const { isLoading } = useHookstate(MESSAGE_FLEET_GLOBAL_STATES);

  const [RoundHoleRefreshChart, setRoundHoleRefreshChart] = useState(true);
  const [AMPHoursPerMilesRefreshChart, setAMPHoursPerMilesRefreshChart] = useState(true);
  const [AMPHoursRefreshChart, setAMPHoursRefreshChart] = useState(true);
  const [OdometerRefreshChart, setOdometerRefreshChart] = useState(true);
  const [KWPerMilesRefreshChart, setKWPerMilesRefreshChart] = useState(true);
  const [KWHoursRefreshChart, setKWHoursRefreshChart] = useState(true);
  const {
    getCarsData,
    getCurrentCarsData,
    getMessagesFromCarsData,
    getFaultsData,
    siteSettingsData,
    getRoundsByCarDetailState,
    getCarUsageDetailState,
    getCarUsageDetailStatus,
    getRoundsByCarState,
    getRoundsByCarStatus,
    siteSettingDataReduxStateStatus,
  } = useSelector((state) => state.commonReducers) || "";

  const filterH = useRef(null);
  // Skips the mount run of the date-range effect so it only re-fetches when
  // the user actually changes Start/End (or presses MTD/QTD/YTD).
  const isFirstDateEffectRef = useRef(true);

  // Raises every Usage graph's Kendo refresh flag so the charts re-apply their
  // options (and therefore repaint with fresh data) after a Refresh / date
  // change, then clears them again once the new data has rendered.
  const triggerChartRefresh = useCallback(() => {
    setRoundHoleRefreshChart(true);
    setAMPHoursPerMilesRefreshChart(true);
    setAMPHoursRefreshChart(true);
    setOdometerRefreshChart(true);
    setKWPerMilesRefreshChart(true);
    setKWHoursRefreshChart(true);
    setTimeout(() => {
      setRoundHoleRefreshChart(false);
      setAMPHoursPerMilesRefreshChart(false);
      setAMPHoursRefreshChart(false);
      setOdometerRefreshChart(false);
      setKWPerMilesRefreshChart(false);
      setKWHoursRefreshChart(false);
    }, 2000);
  }, []);

  //-------filter height ---------------
  useEffect(() => {
    if (filterH.current?.clientHeight === null) {
      return;
    }
  });

  const [includeMemberCars, setIncludeMemberCars] = useState(false);

  let useKMInstead = false;

  const showMonthlyData = () => {
    setMtdState(true);
    setQtdState(false);
    setYTDState(false);
    setStartDate(moment().set("date", 1).format("YYYY-MM-DD"));
    setEndDate(moment(new Date()).format("YYYY-MM-DD"));
  }

  const isMemberCar = isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role) || !getFeatureSetOption(siteSettingsData?.Features, getFeaturesList().member_cars);

  useEffect(() => {
    if (siteId.get() !== null) {
      let startDates = moment(new Date()).format("YYYY-MM-DD");
      startDates = moment().set("date", 1).format("YYYY-MM-DD");

      dispatch(
        COMMON_SERVICES.getRoundsByCarDetailServices(
          siteId.get(),
          startDates.toString(),
          endDate.toString(),
          includeMemberCars
        )
      );

      dispatch(
        COMMON_SERVICES.getCarUsageDetailServices(
          siteId.get(),
          includeMemberCars
        )
      );

      dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
      dispatch(
        COMMON_SERVICES.getExportUsageServices(
          siteId.get(),
          includeMemberCars,
          useKMInstead
        )
      );
    }
  }, [siteId.get(), includeMemberCars]);

  useEffect(() => {
    let isApisubscribed = true;

    if (siteId.get() !== null) {
      if (isApisubscribed) {
        dispatch(
          COMMON_SERVICES.getCarUsageDetailServices(
            siteId.get(),
            includeMemberCars
          )
        );
        dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
        dispatch(
          COMMON_SERVICES.getExportUsageServices(
            siteId.get(),
            includeMemberCars,
            useKMInstead
          )
        );
      }

      showMonthlyData();

      if (getRoundsByCarDetailState) {
        setRoundsByCarTempDetailState(getRoundsByCarDetailState);
      } else {
        setRoundsByCarTempDetailState(null);
      }
    }

    return () => {
      isApisubscribed = false;
    };
  }, [siteId.get(), includeMemberCars]);

  useEffect(() => {
    setRoundHoleRefreshChart(true);
    setTimeout(() => setRoundHoleRefreshChart(false), 2000);
  }, [
    holeStateGlobal.get(),
    roundStateGlobal.get(),
    QtdState,
    MtdState,
    YTDState,
  ]);

  useEffect(() => {
    setRoundHoleRefreshChart(true);
    setAMPHoursPerMilesRefreshChart(true);
    setAMPHoursRefreshChart(true);
    setOdometerRefreshChart(true);
    setKWPerMilesRefreshChart(true);
    setKWHoursRefreshChart(true);
  }, [
    getCarUsageDetailStatus === "success",
    getRoundsByCarStatus === "success",
  ]);
  const carControlType = useMemo(() => {
    return getCarsData.reduce((carControlType, car) => {
      switch (car?.Car?.CarControlType) {
        case 1:
          carControlType.LIN++;
          break;
        case 2:
          carControlType.CAN++;
          break;
        case 3:
          carControlType.GCCM++;
          break;
        default:
          // Handle unknown car control types
          break;
      }
      return carControlType;
    }, { LIN: 0, CAN: 0, GCCM: 0 });
  }, [getCarsData]);
  const avlCarCtrlTypes = useMemo(() => {
    const onlyLIN = carControlType.LIN > 0 && carControlType.CAN === 0 && carControlType.GCCM === 0;
    const onlyCAN = carControlType.LIN === 0 && carControlType.CAN > 0 && carControlType.GCCM === 0;
    const onlyGCCM = carControlType.LIN === 0 && carControlType.CAN === 0 && carControlType.GCCM > 0;
    const allCars = ((carControlType.LIN > 0 && carControlType.CAN > 0) ||
      (carControlType.LIN > 0 && carControlType.GCCM > 0) ||
      (carControlType.CAN > 0 && carControlType.GCCM > 0));

    return { onlyLIN, onlyCAN, onlyGCCM, allCars };
  }, [carControlType]);
  useEffect(() => {
    setRoundHoleRefreshChart(false);
    setAMPHoursPerMilesRefreshChart(false);
    setAMPHoursRefreshChart(false);
    setOdometerRefreshChart(false);
    setKWPerMilesRefreshChart(false);
    setKWHoursRefreshChart(false);
  }, [getCarsData, getCurrentCarsData, getMessagesFromCarsData, getFaultsData]);

  useEffect(() => {
    if (isFirstDateEffectRef.current) {
      isFirstDateEffectRef.current = false;
      return;
    }
    if (siteId.get() !== null) {
      triggerChartRefresh();
      dispatch(
        COMMON_SERVICES.getRoundsByCarDetailServices(
          siteId.get(),
          moment(new Date(startDate)).format("YYYY-MM-DD"),
          moment(new Date(endDate)).format("YYYY-MM-DD"),
          includeMemberCars
        )
      );
    }
  }, [siteId.get(), startDate, endDate, includeMemberCars, triggerChartRefresh, dispatch]);

  useEffect(() => {
    setDomRender(!domRender);
    setRoundHoleRefreshChart(true);
    setTimeout(() => setRoundHoleRefreshChart(false), 2000);
  }, [getRoundsByCarTempDetailState]);

  useEffect(() => {
    if (updatedCarData.get() && updatedCarData.get().length !== 0) {
      let carData = JSON.parse(updatedCarData.get());
      if (carData && Array.isArray(carData) && carData.length !== 0) {
        const carObjData = carData.filter(
          (item) => item?.Car?.GpsiCarId === gpsCardIdStateData.get()
        );
        setTempCarObj(carObjData[0]);
      }
    } else {
      setTempCarObj(null);
    }
  }, [updatedCarData.get()]);

  const ampHoursData =
    getCarUsageDetailState &&
    getCarUsageDetailState !== null &&
    getCarUsageDetailState.CarUsage?.map((item) => {
      var datum = {
        AmpHours: item.AmpHours,
        Odometer: item.Odometer,
        WattHoursPerMile: item.WattHoursPerMile,
        KiloWattHours: item.KiloWattHours,
        AmpHoursPerMile: item.AmpHoursPerMile,
        GpsiCarId: item.GpsiCarId,
        CarNumber: item.CarNumber,
      };
      return datum;
    });

  const aHPerMileZeroFilterData =
    ampHoursData && ampHoursData.filter((item) => item.AmpHoursPerMile !== 0 && item.AmpHoursPerMile !== undefined && item.AmpHoursPerMile !== null);
  const OdometerChartZeroFilterData =
    ampHoursData && ampHoursData.filter((item) => item.Odometer !== 0 && item.Odometer !== undefined && item.Odometer !== null);
  const KWHoursChartZeroFilterData =
    ampHoursData && ampHoursData.filter((item) => item.KiloWattHours !== 0 && item.KiloWattHours !== undefined && item.KiloWattHours !== null);
  const WattHoursPerMileChartZeroFilterData =
    ampHoursData && ampHoursData.filter((item) => item.WattHoursPerMile !== 0 && item.WattHoursPerMile !== undefined && item.WattHoursPerMile !== null);

  // Rows actually drawn on each chart. The value-axis min/max MUST be computed
  // from these exact rows (not from a separately filtered array), otherwise the
  // axis no longer fits the plotted cars and the smallest bar collapses to zero
  // height. (#43227)
  const kiloWattHoursChartRows = KWHoursZeroFilter
    ? KWHoursChartZeroFilterData || []
    : ampHoursData?.filter((item) => item.KiloWattHours !== undefined && item.KiloWattHours !== null) || [];

  const wattHoursPerMileChartRows = WattPerMilesZeroFilter
    ? WattHoursPerMileChartZeroFilterData || []
    : ampHoursData?.filter((item) => item.WattHoursPerMile !== undefined && item.WattHoursPerMile !== null) || [];

  const odometerChartRows = odometerZeroFilter
    ? OdometerChartZeroFilterData || []
    : ampHoursData?.filter((item) => item.Odometer !== undefined && item.Odometer !== null) || [];

  const ampHoursPerMileChartRows = AHPerMilesZeroFilter
    ? aHPerMileZeroFilterData || []
    : ampHoursData?.filter((item) => item.AmpHoursPerMile !== undefined && item.AmpHoursPerMile !== null) || [];

  let filterRoundData = [];
  let filterHolesData = [];
  let filterRoundRow = {};

  if (getRoundsByCarState && getRoundsByCarState.length > 0) {
    for (let i = 0; i < getRoundsByCarState.length; i++) {
      if (getRoundsByCarState[i].Holes > filterRoundData) {
        filterHolesData = getRoundsByCarState[i].Holes;
      }
    }
    for (let i = 0; i < getRoundsByCarState.length; i++) {
      if (getRoundsByCarState[i].Rounds > filterRoundData) {
        filterRoundData = getRoundsByCarState[i].Rounds;
        filterRoundRow = getRoundsByCarState[i];
      }
    }
  }

  const handleClick = () => {
    setOpen(false);
    setMsgToSingleCar.set(null);
  }

  const handleClose = () => {
    setOpen(false);
  }

  const handleClose2 = (event, reason) => {
    if (reason && reason == "backdropClick") return;
    isLoading.set(false);
  }

  const rows = getCarUsageDetailState?.CarUsage?.length > 0 && getCarUsageDetailState?.CarUsage?.map((item, index) => {
    let newRow = { id: index + 1, ...item };
    return newRow;
  });

  const includeZeroOdometerRows =
    rows !== false &&
    rows.filter(
      (item) =>
        item.Odometer === 0 ||
        item.Odometer >
        getCarUsageDetailState.AverageOdometerDetailsIncludesZero?.RangeHigh
    );

  const includeZeroWhPerMilesRows =
    rows !== false &&
    rows.filter(
      (item) =>
        item.WattHoursPerMile === 0 ||
        item.WattHoursPerMile >
        getCarUsageDetailState.AverageWattHoursPerMileDetailsIncludesZero
          ?.RangeHigh
    );

  const includeZeroKWHoursRows =
    rows !== false &&
    rows.filter(
      (item) =>
        item.KiloWattHours === 0 ||
        item.KiloWattHours >
        getCarUsageDetailState.AverageKiloWattHoursDetailsIncludesZero
          ?.RangeHigh
    );

  const includeZeroAMPHoursRows =
    rows !== false &&
    rows.filter(
      (item) =>
        item.AmpHours === 0 ||
        item.AmpHours >
        getCarUsageDetailState.AverageAmpHoursDetailsIncludesZero?.RangeHigh
    );

  const includeZeroAHPerMilesRows =
    rows !== false &&
    rows.filter(
      (item) =>
        item.AmpHoursPerMile === 0 ||
        item.AmpHoursPerMile >
        getCarUsageDetailState.AverageAmpHoursPerMileDetailsIncludesZero
          ?.RangeHigh
    );

  const GetRoundsByCarTable =
    getRoundsByCarDetailState &&
    getRoundsByCarDetailState !== null &&
    getRoundsByCarDetailState !== undefined &&
    getRoundsByCarDetailState?.CarRounds?.length > 0 &&
    getRoundsByCarDetailState?.CarRounds?.map((item, index) => {
      let getGpsiCarId =
        getCarsData &&
        getCarsData !== undefined &&
        getCarsData !== null &&
        getCarsData.length > 0 &&
        getCarsData.filter((items) => items.Car.CarNumber == item.Car);
      let newRow = {
        id: index + 1,
        GpsiCarId: getGpsiCarId[0]?.Car?.GpsiCarId,
        ...item,
      };
      return newRow;
    });

  // Single source of truth for the Odometer graph (same fix as kW / Watt-Hours
  // per Mile): the bar + tooltip colour rule read getCarUsageDetailTempState, a
  // stale snapshot one fetch behind the printed range, so a newly included car
  // could be flagged red against a range different from the one on screen.
  var odometerRangeDetails = odometerZeroFilter
    ? getCarUsageDetailState?.AverageOdometerDetails
    : getCarUsageDetailState?.AverageOdometerDetailsIncludesZero;

  var OdometerZeroFilterValue =
    rows &&
    rows?.filter(
      (item) =>
        item.Odometer !== 0 &&
        (item.Odometer > odometerRangeDetails?.RangeHigh ||
          item.Odometer < odometerRangeDetails?.RangeLow)
    );

  // Same single-source fix as kW below: Watt-Hours/Mile bars + tooltip previously
  // read the getCarUsageDetailTempState snapshot (stale after include-member/site
  // changes) while the printed range was live, so a newly added car could be
  // flagged red against a range different from the one on screen. Bands/outside-
  // range lists also ignored the include-zeros toggle.
  var wattPerMilesRangeDetails = WattPerMilesZeroFilter
    ? getCarUsageDetailState?.AverageWattHoursPerMileDetails
    : getCarUsageDetailState?.AverageWattHoursPerMileDetailsIncludesZero;

  var WhPerMilesZeroFilterValue =
    rows &&
    rows?.filter(
      (item) =>
        item.WattHoursPerMile !== 0 &&
        (item.WattHoursPerMile > wattPerMilesRangeDetails?.RangeHigh ||
          item.WattHoursPerMile < wattPerMilesRangeDetails?.RangeLow)
    );

  // Single source of truth for the kW Hours graph.
  // The bar + tooltip colour rule read getCarUsageDetailTempState, a useState
  // snapshot refreshed only on mount / site change / includeMemberCars and null
  // until the first API response, so bars were flagged red against a range that
  // was not the one printed on screen. Bands/labels also ignored the include-zeros
  // toggle. All consumers now read this live, toggle-aware range.
  var kwhRangeDetails = KWHoursZeroFilter
    ? getCarUsageDetailState?.AverageKiloWattHoursDetails
    : getCarUsageDetailState?.AverageKiloWattHoursDetailsIncludesZero;

  var KWHoursZeroFilterValue =
    rows &&
    rows?.filter(
      (item) =>
        item.KiloWattHours !== 0 &&
        (item.KiloWattHours > kwhRangeDetails?.RangeHigh ||
          item.KiloWattHours < kwhRangeDetails?.RangeLow)
    );

  var ampHoursRangeDetails = AmpHoursZeroFilter
    ? getCarUsageDetailState?.AverageAmpHoursDetails
    : getCarUsageDetailState?.AverageAmpHoursDetailsIncludesZero;

  var AmpHoursZeroFilterValue =
    rows &&
    rows?.filter(
      (item) =>
        item.AmpHours !== 0 &&
        (item.AmpHours > ampHoursRangeDetails?.RangeHigh ||
          item.AmpHours < ampHoursRangeDetails?.RangeLow)
    );

  // Single source of truth for the AH per Mile graph (same fix as kW).
  var ahPerMilesRangeDetails = AHPerMilesZeroFilter
    ? getCarUsageDetailState?.AverageAmpHoursPerMileDetails
    : getCarUsageDetailState?.AverageAmpHoursPerMileDetailsIncludesZero;

  var AHPerMilesZeroFilterValue =
    rows &&
    rows?.filter(
      (item) =>
        item.AmpHoursPerMile !== 0 &&
        (item.AmpHoursPerMile > ahPerMilesRangeDetails?.RangeHigh ||
          item.AmpHoursPerMile < ahPerMilesRangeDetails?.RangeLow)
    );

  const includeZeroOdometer = (e) => {
    setOdometerRefreshChart(true);
    setOdometerZeroFilter(!odometerZeroFilter);
    setTimeout(() => setOdometerRefreshChart(false), 2000);
  }

  const includeZeroWattPerMiles = () => {
    setKWPerMilesRefreshChart(true);
    setWattPerMilesZeroFilter(!WattPerMilesZeroFilter);
    setTimeout(() => setKWPerMilesRefreshChart(false), 2000);
  }

  const includeZeroAmpHours = () => {
    setAMPHoursRefreshChart(true);
    setAmpHoursZeroFilter(!AmpHoursZeroFilter);
    setTimeout(() => setAMPHoursRefreshChart(false), 2000);
  }

  const includeZeroKWHours = () => {
    setKWHoursRefreshChart(true);
    setKWHoursZeroFilter(!KWHoursZeroFilter);
    setTimeout(() => setKWHoursRefreshChart(false), 2000);
  }

  const includeZeroAHPerMiles = () => {
    setAMPHoursPerMilesRefreshChart(true);
    setAHPerMilesZeroFilter(!AHPerMilesZeroFilter);
    setTimeout(() => setAMPHoursPerMilesRefreshChart(false), 2000);
  }

  const style = {
    position: "absolute",
    top: "0",
    maxWidth: "420px",
    width: "100%",
    bgcolor: "#ffffff",
    bottom: "0",
    right: "0",
    height: "100vh",
    border: "0 solid #000",
  };

  const style2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "320px",
    width: "100%",
    bgcolor: "#ffffff",
    zIndex: 1,
  };

  const style3 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "300px",
    width: "calc(100% -  40px)",
    bgcolor: "#ffffff",
    borderRadius: "5px",
    overflow: "hidden",
    paddingTop: 3,
  };

  const activeBtn = {
    background: "#BC9B6A",
    color: "#fff",
    borderColor: "#BC9B6A",
  };

  const refreshFunc = () => {
    triggerChartRefresh();
    dispatch(
      COMMON_SERVICES.getRoundsByCarServices(
        siteId.get(),
        moment(new Date(startDate)).format("YYYY-MM-DD"),
        moment(new Date(endDate)).format("YYYY-MM-DD"),
        includeMemberCars
      )
    );
    dispatch(
      COMMON_SERVICES.getRoundsByCarDetailServices(
        siteId.get(),
        moment(new Date(startDate)).format("YYYY-MM-DD"),
        moment(new Date(endDate)).format("YYYY-MM-DD"),
        includeMemberCars
      )
    );
    setDomRender(!domRender);
  }

  const openDataModal = (e) => {
    setRoundHoleRefreshChart(false);
    setAMPHoursPerMilesRefreshChart(false);
    setAMPHoursRefreshChart(false);
    setOdometerRefreshChart(false);
    setKWPerMilesRefreshChart(false);
    setKWHoursRefreshChart(false);
    // showing car number only if it is available in dataItem to avoid undefined car number in no car data modal
    if (typeof e.dataItem === "object") {
      setClickedCarNumber(e.dataItem.Car);
    } else {
      if (e.row) {
        if (e.row.Car) {
          setClickedCarNumber(e.row.Car);
        }
      }
    }

    const GpsiCarIdData = e.dataItem ? e.dataItem.GpsiCarId : e.row.GpsiCarId;
    gpsCardIdStateData.set(GpsiCarIdData);
    const payload = {
      GpsiCarId: GpsiCarIdData,
    };
    dispatch(COMMON_SERVICES.getProductData(payload));
    const carObj =
      getCarsData &&
      getCarsData !== undefined &&
      getCarsData !== null &&
      getCarsData.filter((item) => item?.Car?.GpsiCarId === GpsiCarIdData);
    setTempCarObj(carObj[0]);
    if (carObj.length > 0) {
      setOpen(true);
    } else {
      // handling modal status to true only in case of car number is availabale
      if (typeof e.dataItem === "object") {
        setOpenCarNotFound(true);
      } else {
        if (e.row) {
          if (e.row.Car) {
            setOpenCarNotFound(true);
          }
        }
      }
    }

    if (updatedCarData.get() && updatedCarData.get().length !== 0) {
      let carData = JSON.parse(updatedCarData.get());
      if (carData && Array.isArray(carData) && carData.length !== 0) {
        const carObjData = carData.filter(
          (item) => item?.Car?.GpsiCarId === GpsiCarIdData
        );
        setTempCarObj(carObjData[0]);
      }
    } else {
      setTempCarObj(null);
    }
  }

  // Statistical helper functions - refactored to use modern JavaScript
  const getAvgFromArray = (arrayToAverage) => {
    if (!arrayToAverage || arrayToAverage.length === 0) return 0;
    const sum = arrayToAverage.reduce((acc, val) => acc + val, 0);
    return sum / arrayToAverage.length;
  };

  const getSigmaOnArray = (arrayToSigma) => {
    if (!arrayToSigma || arrayToSigma.length === 0) return 0;
    
    const average = getAvgFromArray(arrayToSigma);
    const squaredDifferences = arrayToSigma.map(value => 
      Math.pow(value - average, 2)
    );
    const variance = getAvgFromArray(squaredDifferences);
    return Math.sqrt(variance);
  };

  const getMinFromArray = (arrayForMin) => {
    if (!arrayForMin || arrayForMin.length === 0) return 0;
    return Math.min(...arrayForMin);
  };

  const getNumberOfDigits = (numToCheck) => {
    if (numToCheck === 0) return 1;
    return Math.floor(Math.log10(Math.abs(numToCheck))) + 1;
  };

  const roundDownNearestPow10 = (valueToRound) => {
    if (valueToRound <= 0) return 0;
    if (valueToRound < 10) return Math.floor(valueToRound);
    
    const numDigits = getNumberOfDigits(valueToRound);
    const roundDigit = numDigits - 1;
    const roundTo = Math.pow(10, roundDigit);
    return Math.floor(valueToRound / roundTo) * roundTo;
  };

  const getMinMaxForChart = (chartArray, avgFromArray, sigmaFromArray) => {
    if (!chartArray || chartArray.length === 0) {
      return { Min: 0, Max: 0 };
    }

    // Get min and max from array
    const arrayMin = roundDownNearestPow10(getMinFromArray(chartArray));

    // Get min and max based on 2 sigmas from avg
    const maxFromAvg = avgFromArray + (2 * sigmaFromArray);
    const minFromAvg = roundDownNearestPow10(avgFromArray - (2 * sigmaFromArray));

    let tempChartMin;
    
    // Compare the two, use min from array if lower since it will include all cars
    if (arrayMin < minFromAvg) {
      tempChartMin = arrayMin < 0 ? 0 : arrayMin;
    } else if (arrayMin === minFromAvg) {
      const range = maxFromAvg - minFromAvg;
      if (range < 10) {
        // Really small range
        tempChartMin = arrayMin <= 0 ? 0 : arrayMin - 0.2;
      } else {
        const numDigs = getNumberOfDigits(range) - 1;
        tempChartMin = arrayMin <= 0 ? 0 : arrayMin - Math.pow(10, numDigs);
      }
    } else {
      tempChartMin = minFromAvg < 0 ? 0 : minFromAvg;
    }

    // Set max based on min to keep avg line in the middle
    const diffBetweenAvgAndMin = avgFromArray - tempChartMin;
    const tempChartMax = avgFromArray + diffBetweenAvgAndMin;

    return {
      Min: tempChartMin,
      Max: tempChartMax
    };
  };

  // Axis min/max computed the legacy way: avg and sigma are derived client-side
  // from the SAME array the bars are drawn from, both rounded with Math.round.
  // (#43227)
  const getChartAxisMinMax = (dataArray) => {
    if (!dataArray || dataArray.length === 0) {
      return { Min: 0, Max: 0 };
    }

    const avg = Math.round(getAvgFromArray(dataArray));
    const sigma = Math.round(getSigmaOnArray(dataArray));
    const minMax = getMinMaxForChart(dataArray, avg, sigma);

    return {
      Min: minMax.Min > 0 ? minMax.Min : 0,
      Max: minMax.Max
    };
  };

  // Axis min/max for the four charts that share this pattern (#43227). Declared
  // after getChartAxisMinMax above; consumed by the value axes further down.
  const kiloWattHoursAxisMinMax = getChartAxisMinMax(kiloWattHoursChartRows.map((o) => o.KiloWattHours));
  const wattHoursPerMileAxisMinMax = getChartAxisMinMax(wattHoursPerMileChartRows.map((o) => o.WattHoursPerMile));
  const odometerAxisMinMax = getChartAxisMinMax(odometerChartRows.map((o) => o.Odometer));
  const ampHoursPerMileAxisMinMax = getChartAxisMinMax(ampHoursPerMileChartRows.map((o) => o.AmpHoursPerMile));

  let tempArrayAVG = []; //to get average
  if (
    getRoundsByCarDetailState &&
    Object.keys(getRoundsByCarDetailState).length > 0
  ) {
    for (
      var i = 0, rlength = getRoundsByCarDetailState.CarRounds.length;
      i < rlength;
      i++
    ) {
      if (roundStateGlobal.get()) {
        tempArrayAVG.push(getRoundsByCarDetailState.CarRounds[i].Rounds);
      } else {
        tempArrayAVG.push(getRoundsByCarDetailState.CarRounds[i].Holes);
      }
    }
  }

  var sigmaRounds = !isNaN(Math.round(getSigmaOnArray(tempArrayAVG)))
    ? Math.round(getSigmaOnArray(tempArrayAVG))
    : 0;
  var averageRounds = !isNaN(Math.round(getAvgFromArray(tempArrayAVG)))
    ? Math.round(getAvgFromArray(tempArrayAVG))
    : 0;
  var roundsMinMax = getMinMaxForChart(
    tempArrayAVG,
    !isNaN(averageRounds) ? averageRounds : 0,
    !isNaN(sigmaRounds) ? sigmaRounds : 0
  );

  var roundsMax = roundsMinMax.Max;
  var roundsMin = roundsMinMax.Min <= 1 ? 0 : roundsMinMax.Min; //if min is 1, start chart at 0 to show cars with min (or anything less since no negative rounds)

  var rangeLowRounds = null;

  const rangeHighRounds = averageRounds + sigmaRounds;

  if (averageRounds - sigmaRounds < 0) {
    rangeLowRounds = 0;
  } else {
    rangeLowRounds = averageRounds - sigmaRounds;
  }

  // Use the backend-provided range for the Rounds/Holes graph color rule
  // (same source as every other Usage graph). Falls back to the FE avg/sigma
  // band if the backend details are absent. (#52847)
  const roundsRangeDetails = roundStateGlobal.get()
    ? getRoundsByCarDetailState?.AverageRoundDetails
    : getRoundsByCarDetailState?.AverageHoleDetails;

  const roundsBandHigh = roundsRangeDetails?.RangeHigh ?? rangeHighRounds;
  const roundsBandLow = roundsRangeDetails?.RangeLow ?? rangeLowRounds;
  const roundsBandAvg = roundsRangeDetails?.Average ?? averageRounds;

  const getTooltipColor = (points) => {
    if (
      getRoundsByCarDetailState &&
      Object.keys(getRoundsByCarDetailState).length > 0
    ) {
      if (
        points > roundsBandHigh ||
        points < roundsBandLow ||
        (roundsRangeDetails?.RangeLow === 0 && points === 0)
      ) {
        return "red";
      } else {
        return "green";
      }
    }
  }

  const avarageRoundDataValue =
    GetRoundsByCarTable !== false &&
    GetRoundsByCarTable.filter(
      (item) =>
        item?.Holes >
        getRoundsByCarDetailState?.AverageHoleDetails?.RangeHigh ||
        item?.Holes < getRoundsByCarDetailState?.AverageHoleDetails?.RangeLow ||
        item?.Rounds >
        getRoundsByCarDetailState?.AverageRoundDetails?.RangeHigh ||
        item?.Rounds < rangeLowRounds
    );

  const uniqueObjects = {};

  // Filter and update uniqueObjects with objects where Rounds > 9 and < 2
  const filteredRangeData =
    avarageRoundDataValue?.length &&
    avarageRoundDataValue.filter((obj) => {
      const roundsValue = obj.Rounds;

      // If the Rounds value is greater than 9 and less than 2, include it
      if (roundsValue > rangeHighRounds || roundsValue < rangeLowRounds) {
        // Check for duplicates
        if (
          !(roundsValue in uniqueObjects) ||
          obj.Rounds > uniqueObjects[roundsValue].Rounds
        ) {
          uniqueObjects[roundsValue] = obj;
        }
        return true;
      }

      return false;
    });

  const SharedRoundTooltip = (props) => {
    const { points } = props;
    return (
      <div
        style={{
          backgroundColor: getTooltipColor(points[0].value),
          padding: "0px 5px 0px 5px",
        }}
      >
        {roundStateGlobal.get() ? (
          <>
            {t("Car")} {points[0]?.dataItem?.Car} {t("Rounds")}{" "}
            {points[0]?.dataItem?.Rounds}
          </>
        ) : (
          <>
            {t("Car")} {points[0]?.dataItem?.Car} {t("Holes")}{" "}
            {points[0]?.dataItem?.Holes}
          </>
        )}
      </div>
    );
  }

  const SharedTooltip = (props) => {
    const { points } = props;
    return (
      <div>
        Car {points[0]?.dataItem?.CarNumber} {t("Amp_Hours")}{" "}
        {points[0]?.dataItem?.AmpHours}
      </div>
    );
  }

  const SharedWHMilesTooltip = (props) => {
    const { points } = props;
    const value = points[0]?.dataItem?.WattHoursPerMile;
    const rangeDetails = wattPerMilesRangeDetails;
    
    const backgroundColor = (value > rangeDetails?.RangeHigh || value < rangeDetails?.RangeLow || (rangeDetails?.RangeLow === 0 && value === 0)) 
      ? "red" 
      : "green";

    return (
      <ChartTooltipSection style={{ backgroundColor }}>
        Car {points[0]?.dataItem?.CarNumber} {t("WH_per_Mile")}{" "}
        {value}
      </ChartTooltipSection>
    );
  }

  const SharedKWHoursTooltip = (props) => {
    const { points } = props;
    const value = points[0]?.dataItem?.KiloWattHours;
    const rangeDetails = kwhRangeDetails;
    
    const backgroundColor = (value > rangeDetails?.RangeHigh || value < rangeDetails?.RangeLow || (rangeDetails?.RangeLow === 0 && value === 0)) 
      ? "red" 
      : "green";

    return (
      <ChartTooltipSection style={{ backgroundColor }}>
        Car {points[0]?.dataItem?.CarNumber} {t("kW_Hours")}{" "}
        {value}
      </ChartTooltipSection>
    );
  }

  const SharedOdometerTooltip = (props) => {
    const { points } = props;
    const value = points[0]?.dataItem?.Odometer;
    const rangeDetails = odometerRangeDetails;
    
    const backgroundColor = (value > rangeDetails?.RangeHigh || value < rangeDetails?.RangeLow || (rangeDetails?.RangeLow === 0 && value === 0)) 
      ? "red" 
      : "green";

    if (value === 0) return "";
    return (
      <ChartTooltipSection style={{ backgroundColor }}>
        Car {points[0]?.dataItem?.CarNumber} {t("odometer")}{" "}
        {value}
      </ChartTooltipSection>
    );
  }

  const SharedAHPermileTooltip = (props) => {
    const { points } = props;
    const value = points[0]?.dataItem?.AmpHoursPerMile;
    const rangeDetails = ahPerMilesRangeDetails;
    
    const backgroundColor = (value > rangeDetails?.RangeHigh || value < rangeDetails?.RangeLow || (rangeDetails?.RangeLow === 0 && value === 0)) 
      ? "red" 
      : "green";

    return (
      <ChartTooltipSection style={{ backgroundColor }}>
        Car {points[0]?.dataItem?.CarNumber} {t("AH_per_Mile")}{" "}
        {value}
      </ChartTooltipSection>
    );
  }

  const sharedTooltipRender = (context) => <SharedTooltip {...context} />;
  const sharedRoundTooltipRender = (roundContext) => (
    <SharedRoundTooltip {...roundContext} />
  );
  const sharedOdometerTooltipRender = (contexts) => (
    <SharedOdometerTooltip {...contexts} />
  );
  const sharedKWHoursTooltipRender = (contexts) => (
    <SharedKWHoursTooltip {...contexts} />
  );
  const sharedWhMilesTooltipRender = (contexts) => (
    <SharedWHMilesTooltip {...contexts} />
  );
  const sharedAHPerMileTooltipRender = (AHPerMilecontext) => (
    <SharedAHPermileTooltip {...AHPerMilecontext} />
  );

  // Cross-graph tooltip sync.
  // The old per-chart tooltips (render fns above) are reused as-is. When a bar
  // is hovered on ANY Usage chart we call the underlying chart instance's
  // public `showTooltip(filter)` API on EVERY chart, so each graph opens its
  // own tooltip at the matching car's bar — same behaviour as the legacy SPA,
  // which mirrored tooltips across all `.usageCharts`. `hideTooltip` clears
  // them all when the pointer leaves the charts.
  const getPointCarNumber = (point) =>
    point?.dataItem?.CarNumber ?? point?.dataItem?.Car ?? null;

  const handleUsageChartHover = (e) => {
    const carNumber = e?.dataItem?.CarNumber ?? e?.dataItem?.Car ?? null;
    if (carNumber === null || carNumber === undefined) return;
    const key = String(carNumber);
    const container = usageContainerRef.current;
    const containerRect = container
      ? container.getBoundingClientRect()
      : null;
    const visibleTop = containerRect ? containerRect.top : 0;
    const visibleBottom = containerRect
      ? containerRect.bottom
      : window.innerHeight || document.documentElement.clientHeight;
    Object.values(chartInstancesRef.current).forEach((chartInstance) => {
      if (chartInstance && typeof chartInstance.showTooltip === "function") {
        const element = chartInstance.element;
        if (element && typeof element.getBoundingClientRect === "function") {
          const rect = element.getBoundingClientRect();
          // Show on any chart with a visible part, including partially
          // scrolled ones.
          if (rect.bottom <= visibleTop || rect.top >= visibleBottom) return;
        }
        try {
          chartInstance.showTooltip(
            (point) => String(getPointCarNumber(point)) === key
          );
        } catch (error) {
          // tooltip not ready yet — ignore
        }
      }
    });
    // Kendo portals the tooltips to <body> with a higher z-index than the top
    // navbar, so a tooltip whose bar is near the top can render over the
    // navbar. Nudge any that cross the container's top edge back inside.
    const clampTooltips = () => {
      const activeContainer = usageContainerRef.current;
      if (!activeContainer) return;
      const top = activeContainer.getBoundingClientRect().top;
      document
        .querySelectorAll(".k-animation-container.k-chart-tooltip-wrapper")
        .forEach((tooltip) => {
          const rect = tooltip.getBoundingClientRect();
          if (rect.top < top) {
            const currentTop = parseFloat(tooltip.style.top) || 0;
            tooltip.style.top = currentTop + (top - rect.top) + "px";
          }
        });
    };
    requestAnimationFrame(() => requestAnimationFrame(clampTooltips));
  };

  const handleChartsMouseLeave = () => {
    Object.values(chartInstancesRef.current).forEach((chartInstance) => {
      if (chartInstance && typeof chartInstance.hideTooltip === "function") {
        try {
          chartInstance.hideTooltip();
        } catch (error) {
          // ignore
        }
      }
    });
  };

  function paceString() {
    let result = "";
    if (TempCarObj) {
      if (TempCarObj?.Car?.Pace > 0)
        result = TempCarObj?.Car?.Pace.toString() + " min ahead ";
      else if (TempCarObj?.Car?.Pace < 0)
        result = (-TempCarObj?.Car?.Pace).toString() + " min behind ";
      else result = "on pace ";
      if (TempCarObj?.Car?.HolesPlayed > 0)
        result =
          result +
          "through " +
          TempCarObj?.Car?.HolesPlayed.toString() +
          " hole" +
          (TempCarObj?.Car?.HolesPlayed > 1 ? "s" : "");
    }
    return result;
  }

  const RounddownloadFile = async () => {
    try {
      let response = await API_CALLS.getExportRoundByCarApiCall(
        siteId.get(),
        includeMemberCars,
        startDate,
        endDate,
        headersConfigData
      );
      let jsonResponse = await response.text();
      let hiddenElement = document.createElement("a");
      hiddenElement.href =
        "data:text/csv;charset=utf-8," + encodeURIComponent(jsonResponse);
      hiddenElement.target = "_blank";
      hiddenElement.download = "Car Rounds.csv";
      hiddenElement.click();
    } catch (error) { }
  }

  const downloadFile = async () => {
    let SiteName =
      siteSettingsData &&
      siteSettingsData !== undefined &&
      siteSettingsData?.Name;
    var fileName = `Car Usage - ${SiteName} - ${moment(new Date()).format(
      "DDMMMYYYY"
    )}.csv`;

    try {
      let response = await API_CALLS.getExportUsageApiCall(
        siteId.get(),
        includeMemberCars,
        useKMInstead,
        headersConfigData
      );
      let jsonResponse = await response.text();
      let hiddenElement = document.createElement("a");
      hiddenElement.href =
        "data:text/csv;charset=utf-8," + encodeURIComponent(jsonResponse);
      hiddenElement.target = "_blank";
      hiddenElement.download = fileName;
      hiddenElement.click();
    } catch (error) { }
  }

  if (siteSettingDataReduxStateStatus === API_STATUSES.REQUEST) {
    return <Loader />;
  }

  const showYearlyData = () => {
    setMtdState(false);
    setQtdState(false);
    setYTDState(true);
    setStartDate(moment().set({ date: 1, month: 0 }).format("YYYY-MM-DD"));
    setEndDate(moment(new Date()).format("YYYY-MM-DD"));
  }

  const showQuaterlyData = () => {
    setMtdState(false);
    setQtdState(true);
    setYTDState(false);
    let getQuater = Math.floor(moment().month() / 3);
    setStartDate(
      moment()
        .set({ date: 1, month: getQuater * 3 })
        .format("YYYY-MM-DD")
    );
    setEndDate(moment(new Date()).format("YYYY-MM-DD"));
  }


  const handleKWHoursChartRefresh = (chartOptions, themeOptions, chartInstance) => {
    chartInstancesRef.current.kwHours = chartInstance;
    if (KWHoursRefreshChart) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
  }

  const handleWPPerMilesChartRefresh = (chartOptions, themeOptions, chartInstance) => {
    chartInstancesRef.current.whPerMile = chartInstance;
    if (KWPerMilesRefreshChart) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
  }

  const handleOdometerChartRefresh = (chartOptions, themeOptions, chartInstance) => {
    chartInstancesRef.current.odometer = chartInstance;
    if (OdometerRefreshChart) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
  }

  const handleAMPHoursChartRefresh = (chartOptions, themeOptions, chartInstance) => {
    chartInstancesRef.current.ampHours = chartInstance;
    if (AMPHoursRefreshChart) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
  }

  const handleAMPHoursPerMilesChartRefresh = (chartOptions, themeOptions, chartInstance) => {
    chartInstancesRef.current.ahPerMile = chartInstance;
    if (AMPHoursPerMilesRefreshChart) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
  }

  const handleRoundHoleChartRefresh = (chartOptions, themeOptions, chartInstance) => {
    chartInstancesRef.current.roundHole = chartInstance;
    if (RoundHoleRefreshChart) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
  }

  const handleKiloWattHoursColor = (e) => {
    const rangeDetails = kwhRangeDetails;
    
    if (!rangeDetails || rangeDetails.RangeHigh === undefined || rangeDetails.RangeLow === undefined) {
      return "green";
    }
    
    if (e.value > rangeDetails.RangeHigh || e.value < rangeDetails.RangeLow ||
      (rangeDetails.RangeLow === 0 && e.value === 0)) {
      return "red";
    } else {
      return "green";
    }
  }

  const handleWattHoursPerMileColor = (e) => {
    const rangeDetails = wattPerMilesRangeDetails;
    
    if (!rangeDetails || rangeDetails.RangeHigh === undefined || rangeDetails.RangeLow === undefined) {
      return "green";
    }
    
    if (e.value > rangeDetails.RangeHigh || e.value < rangeDetails.RangeLow ||
      (rangeDetails.RangeLow === 0 && e.value === 0)) {
      return "red";
    } else {
      return "green";
    }
  }

  const handleRoundsColor = (e) => {
    if (
      !roundsRangeDetails ||
      roundsRangeDetails.RangeHigh === undefined ||
      roundsRangeDetails.RangeLow === undefined
    ) {
      return "green";
    }

    if (
      e.value > roundsRangeDetails.RangeHigh ||
      e.value < roundsRangeDetails.RangeLow ||
      (roundsRangeDetails.RangeLow === 0 && e.value === 0)
    ) {
      return "red";
    } else {
      return "green";
    }
  }

  const handleAmpHoursPerMileColor = (e) => {
    const rangeDetails = ahPerMilesRangeDetails;
    
    if (!rangeDetails || rangeDetails.RangeHigh === undefined || rangeDetails.RangeLow === undefined) {
      return "green";
    }
    
    if (e.value > rangeDetails.RangeHigh || e.value < rangeDetails.RangeLow ||
      (rangeDetails.RangeLow === 0 && e.value === 0)) {
      return "red";
    } else {
      return "green";
    }
  }

  const handleOdometerColor = (e) => {
    const rangeDetails = odometerRangeDetails;
    
    if (!rangeDetails || rangeDetails.RangeHigh === undefined || rangeDetails.RangeLow === undefined) {
      return "green";
    }
    
    if (e.value > rangeDetails.RangeHigh || e.value < rangeDetails.RangeLow ||
      (rangeDetails.RangeLow === 0 && e.value === 0)) {
      return "red";
    } else {
      return "green";
    }
  }

  return (
    <Wrapper>

      <UsageContainer
        ref={usageContainerRef}
        onScroll={handleChartsMouseLeave}
      >
        {isMemberCar &&
          <Tooltip title={t("Include_Member_Cars")} className="title">
            <FormControlLabel
              label={t("Include_Member_Cars")}
              control={
                <Checkbox
                  checked={includeMemberCars}
                  onClick={() => setIncludeMemberCars(!includeMemberCars)}
                  icon={<UnCheckIcon width={20} height={20} />}
                  checkedIcon={
                    <CheckIcon width={20} height={20} />
                  }
                />
              }
            />
          </Tooltip>}
        {(avlCarCtrlTypes.allCars || avlCarCtrlTypes.onlyCAN) && <ChartRow>
          <div onMouseLeave={handleChartsMouseLeave}>
            {getCarUsageDetailState &&
              getCarUsageDetailState !== null &&
              getCarUsageDetailState !== undefined &&
              getCarUsageDetailState?.AverageKiloWattHoursDetails !== null ? (
              <Chart
                onRefresh={handleKWHoursChartRefresh}
                onSeriesClick={(e) => openDataModal(e)}
                onSeriesHover={handleUsageChartHover}
              >
                <ChartArea background="#fff" margin={0} />
                <ChartLegend visible={false} />
                <ChartTitle text={t("kW_Hours")} font="14pt sans-serif" />
                <ChartTooltip
                  border={{ color: "white" }}
                  background="transparent"
                  color="white"
                  shared={true}
                  render={sharedKWHoursTooltipRender}
                  visible={true}
                />
                <ChartSeriesDefaults type="column" line={{ width: 1 }} />
                <ChartCategoryAxis>
                  <ChartCategoryAxisItem
                    axisCrossingValue={0}
                    minorTicks={{ visible: false }}
                    labels={{ visible: false }}
                    field="CarNumber"
                  />
                </ChartCategoryAxis>
                <ChartValueAxis>
                  <ChartValueAxisItem
                    axisCrossingValue={0}
                    labels={{
                      color: "black",
                      format: "{0}",
                    }}
                    plotBands={[
                      {
                        from: kwhRangeDetails?.RangeHigh,
                        to: 1000000,
                        color: "red",
                        opacity: 0.1,
                      },
                      {
                        from: kwhRangeDetails?.RangeLow,
                        to: -1000000,
                        color: "red",
                        opacity: 0.1,
                      },
                      {
                        from: kwhRangeDetails?.Average,
                        to: kwhRangeDetails?.RangeHigh,
                        color: "green",
                        opacity: 0.2,
                      },
                      {
                        from: kwhRangeDetails?.Average,
                        to: kwhRangeDetails?.RangeLow,
                        color: "green",
                        opacity: 0.2,
                      },
                    ]}
                    min={kiloWattHoursAxisMinMax.Min}
                    max={kiloWattHoursAxisMinMax.Max}
                    minorTicks={{ visible: false }}
                  />
                </ChartValueAxis>
                <ChartSeries>
                  <ChartSeriesItem
                    gap={0}
                    line={1}
                    type="column"
                    stack={false}
                    field="KiloWattHours"
                    name="KiloWattHours"
                    color={(e) => handleKiloWattHoursColor(e)}
                    data={
                      KWHoursZeroFilter
                        ? KWHoursChartZeroFilterData !== undefined &&
                        KWHoursChartZeroFilterData.sort(
                          (a, b) => a.KiloWattHours - b.KiloWattHours
                        )
                        : ampHoursData !== undefined &&
                        ampHoursData.filter((item) => item.KiloWattHours !== undefined && item.KiloWattHours !== null).sort(
                          (a, b) => a.KiloWattHours - b.KiloWattHours
                        )
                    }
                  />

                  <ChartSeriesItem
                    type="line"
                    style="smooth"
                    name="Average"
                    color="black"
                    markers={{
                      visible: false,
                    }}
                  />
                </ChartSeries>
              </Chart>
            ) : (
              <>
                <strong>{t("kW_Hours")}</strong>
                <br />
                {t("No_data")}
              </>
            )}
          </div>
          <div>
            <div className="heading">
              <div>
                {t("Average")}: {kwhRangeDetails?.Average}{" "}
              </div>
              <div>
                {t("Range")}: {formatRangeValue(kwhRangeDetails?.RangeLow)} -{" "}
                {formatRangeValue(kwhRangeDetails?.RangeHigh)}{" "}
              </div>
              <div>{t("Cars_outside_range")}</div>
            </div>
            <DataGrid
              rows={
                KWHoursZeroFilter
                  ? KWHoursZeroFilterValue !== null && KWHoursZeroFilterValue
                  : rows !== null && includeZeroKWHoursRows
              }
              columns={[
                {
                  field: "CarNumber",
                  headerName: "Car",
                  width: 180,
                  sortable: true,
                },
                {
                  field: "KiloWattHours",
                  headerName: t("kW_Hours"),
                  width: 180,
                  sortable: true,
                },
              ]}
              onRowClick={(e) => openDataModal(e)}
              pageSize={
                (KWHoursZeroFilter
                  ? KWHoursZeroFilterValue !== null &&
                  KWHoursZeroFilterValue.length
                  : rows !== null && includeZeroKWHoursRows.length) > 100 ? 100 : (KWHoursZeroFilter
                    ? KWHoursZeroFilterValue !== null &&
                    KWHoursZeroFilterValue.length
                    : rows !== null && includeZeroKWHoursRows.length)
              }
            />
            <div className="action-btn">
              <div>
                <input
                  type="checkbox"
                  onChange={(e) => includeZeroKWHours(e)}
                />{" "}
                Include zeros
              </div>
              <button onClick={downloadFile}>{t("Download")}</button>
            </div>
          </div>
        </ChartRow>}
        {/* Chart of WH per Mile */}
        {(avlCarCtrlTypes.allCars || avlCarCtrlTypes.onlyCAN) &&<ChartRow>
          <div onMouseLeave={handleChartsMouseLeave}>
            {getCarUsageDetailState &&
              getCarUsageDetailState !== null &&
              getCarUsageDetailState !== undefined &&
              getCarUsageDetailState?.AverageKiloWattHoursDetails !== null ? (
              <Chart
                onRefresh={handleWPPerMilesChartRefresh}
                onSeriesClick={(e) => openDataModal(e)}
                onSeriesHover={handleUsageChartHover}
              >
                <ChartArea background="#fff" margin={0} />
                <ChartLegend visible={false} />
                <ChartTitle text={t("WH_per_Mile")} font="14pt sans-serif" />
                <ChartTooltip
                  border={{ color: "white" }}
                  background="transparent"
                  color="white"
                  shared={true}
                  render={sharedWhMilesTooltipRender}
                  visible={true}
                />
                <ChartSeriesDefaults type="column" line={{ width: 1 }} />
                <ChartCategoryAxis>
                  <ChartCategoryAxisItem
                    axisCrossingValue={0}
                    minorTicks={{ visible: false }}
                    labels={{ visible: false }}
                    field="CarNumber"
                  />
                </ChartCategoryAxis>
                <ChartValueAxis>
                  <ChartValueAxisItem
                    axisCrossingValue={0}
                    labels={{
                      color: "black",
                      format: "{0}",
                    }}
                    plotBands={[
                      {
                        from: wattPerMilesRangeDetails?.RangeHigh,
                        to: 1000000,
                        color: "red",
                        opacity: 0.1,
                      },
                      {
                        from: wattPerMilesRangeDetails?.RangeLow,
                        to: -1000000,
                        color: "red",
                        opacity: 0.1,
                      },
                      {
                        from: wattPerMilesRangeDetails?.Average,
                        to: wattPerMilesRangeDetails?.RangeHigh,
                        color: "green",
                        opacity: 0.2,
                      },
                      {
                        from: wattPerMilesRangeDetails?.Average,
                        to: wattPerMilesRangeDetails?.RangeLow,
                        color: "green",
                        opacity: 0.2,
                      },
                    ]}
                    min={wattHoursPerMileAxisMinMax.Min}
                    max={wattHoursPerMileAxisMinMax.Max}
                    minorTicks={{ visible: false }}
                  />
                </ChartValueAxis>
                <ChartSeries>
                  <ChartSeriesItem
                    gap={0}
                    line={1}
                    type="column"
                    stack={false}
                    field="WattHoursPerMile"
                    name="WattHoursPerMile"
                    color={(e) => handleWattHoursPerMileColor(e)}
                    data={
                      WattPerMilesZeroFilter
                        ? WattHoursPerMileChartZeroFilterData !== undefined &&
                        WattHoursPerMileChartZeroFilterData.sort(
                          (a, b) => a.WattHoursPerMile - b.WattHoursPerMile
                        )
                        : ampHoursData !== undefined &&
                        ampHoursData.filter((item) => item.WattHoursPerMile !== undefined && item.WattHoursPerMile !== null).sort(
                          (a, b) => a.WattHoursPerMile - b.WattHoursPerMile
                        )
                    }
                  />

                  <ChartSeriesItem
                    type="line"
                    style="smooth"
                    name="Average"
                    color="black"
                    markers={{
                      visible: false,
                    }}
                  />
                </ChartSeries>
              </Chart>
            ) : (
              <>
                <strong>{t("WH_per_Mile")}</strong>
                <br />
                {t("No_data")}
              </>
            )}
          </div>
          <div>
            <div className="heading">
              <div>
                {t("Average")}: {wattPerMilesRangeDetails?.Average}{" "}
              </div>
              <div>
                {t("Range")}: {formatRangeValue(wattPerMilesRangeDetails?.RangeLow)} -{" "}
                {formatRangeValue(wattPerMilesRangeDetails?.RangeHigh)}{" "}
              </div>
              <div>{t("Cars_outside_range")}</div>
            </div>
            <DataGrid
              rows={
                WattPerMilesZeroFilter
                  ? WhPerMilesZeroFilterValue !== null &&
                  WhPerMilesZeroFilterValue
                  : rows !== null && includeZeroWhPerMilesRows
              }
              columns={[
                {
                  field: "CarNumber",
                  headerName: "Car",
                  width: 180,
                  sortable: true,
                },
                {
                  field: "WattHoursPerMile",
                  headerName: t("WH/Mile"),
                  width: 180,
                  sortable: true,
                },
              ]}
              onRowClick={(e) => openDataModal(e)}
              pageSize={
                (WattPerMilesZeroFilter
                  ? WhPerMilesZeroFilterValue !== null &&
                  WhPerMilesZeroFilterValue.length
                  : rows !== null && includeZeroWhPerMilesRows.length) > 100 ? 100 : (WattPerMilesZeroFilter
                    ? WhPerMilesZeroFilterValue !== null &&
                    WhPerMilesZeroFilterValue.length
                    : rows !== null && includeZeroWhPerMilesRows.length)
              }
            />
            <div className="action-btn">
              <div>
                <input
                  type="checkbox"
                  onChange={(e) => includeZeroWattPerMiles(e)}
                />{" "}
                Include zeros
              </div>
              <button onClick={downloadFile}>{t("Download")}</button>
            </div>
          </div>
        </ChartRow>}

        {/* Chart of odometer */}
        <ChartRow>
          <div onMouseLeave={handleChartsMouseLeave}>
            {getCarUsageDetailState &&
              getCarUsageDetailState !== null &&
              getCarUsageDetailState !== undefined &&
              getCarUsageDetailState?.AverageOdometerDetails !== null ? (
              <Chart
                onRefresh={handleOdometerChartRefresh}
                onSeriesClick={(e) => openDataModal(e)}
                onSeriesHover={handleUsageChartHover}
              >
                <ChartArea background="#fff" margin={0} />
                <ChartLegend visible={false} />
                <ChartTitle text={t("odometer")} font="14pt sans-serif" />
                <ChartTooltip
                  border={{ color: "white" }}
                  background="transparent"
                  color="white"
                  shared={true}
                  render={sharedOdometerTooltipRender}
                  visible={true}
                />
                <ChartSeriesDefaults type="column" line={{ width: 1 }} />
                <ChartCategoryAxis>
                  <ChartCategoryAxisItem
                    axisCrossingValue={0}
                    minorTicks={{ visible: false }}
                    labels={{ visible: false }}
                    field="CarNumber"
                  />
                </ChartCategoryAxis>
                <ChartValueAxis>
                  <ChartValueAxisItem
                    axisCrossingValue={0}
                    labels={{
                      color: "black",
                      format: "{0}",
                    }}
                    plotBands={[
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageOdometerDetails
                            ?.RangeHigh,
                        to: 1000000,
                        color: "red",
                        opacity: 0.1,
                      },
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageOdometerDetails
                            ?.RangeLow,
                        to: -1000000,
                        color: "red",
                        opacity: 0.1,
                      },
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageOdometerDetails
                            ?.Average,
                        to:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageOdometerDetails
                            ?.RangeHigh,
                        color: "green",
                        opacity: 0.2,
                      },
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageOdometerDetails
                            ?.Average,
                        to:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageOdometerDetails
                            ?.RangeLow,
                        color: "green",
                        opacity: 0.2,
                      },
                    ]}
                    min={odometerAxisMinMax.Min}
                    max={odometerAxisMinMax.Max}
                    minorTicks={{ visible: false }}
                  />
                </ChartValueAxis>
                <ChartSeries>
                  <ChartSeriesItem
                    gap={0}
                    line={1}
                    field="Odometer"
                    name="Odometer"
                    color={(e) => handleOdometerColor(e)}
                    data={
                      odometerZeroFilter
                        ? OdometerChartZeroFilterData !== undefined &&
                        OdometerChartZeroFilterData.sort(
                          (a, b) => a.Odometer - b.Odometer
                        )
                        : ampHoursData !== undefined &&
                        ampHoursData.filter((item) => item.Odometer !== undefined && item.Odometer !== null).sort((a, b) => a.Odometer - b.Odometer)
                    }
                  />

                  <ChartSeriesItem
                    type="line"
                    style="smooth"
                    name="Average"
                    color="black"
                    markers={{
                      visible: false,
                    }}
                  />
                </ChartSeries>
              </Chart>
            ) : (
              <>
                <strong>{t("odometer")}</strong>
                <br />
                {t("No_data")}
              </>
            )}
          </div>
          <div>
            <div className="heading">
              <div>
                {t("Average")}:{" "}
                {odometerZeroFilter
                  ? getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageOdometerDetails?.Average
                  : getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageOdometerDetailsIncludesZero
                    ?.Average}{" "}
              </div>
              <div>
                {t("Range")}:{" "}
                {odometerZeroFilter
                  ? getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageOdometerDetails?.RangeLow
                  : getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageOdometerDetailsIncludesZero
                    ?.RangeLow}{" "}
                -{" "}
                {odometerZeroFilter
                  ? getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageOdometerDetails?.RangeHigh
                  : getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageOdometerDetailsIncludesZero
                    ?.RangeHigh}{" "}
              </div>
              <div>{t("Cars_outside_range")}</div>
            </div>
            <DataGrid
              rows={
                odometerZeroFilter
                  ? OdometerZeroFilterValue !== null && OdometerZeroFilterValue
                  : rows !== null && includeZeroOdometerRows
              }
              onRowClick={(e) => openDataModal(e)}
              columns={[
                {
                  field: "CarNumber",
                  headerName: t("car"),
                  width: 180,
                  sortable: true,
                },
                {
                  field: "Odometer",
                  headerName: t("odometer"),
                  width: 180,
                  sortable: true,
                },
              ]}
              pageSize={
                (odometerZeroFilter
                  ? OdometerZeroFilterValue !== null &&
                  OdometerZeroFilterValue.length
                  : rows !== null && includeZeroOdometerRows.length) > 100 ? 100 : (odometerZeroFilter
                    ? OdometerZeroFilterValue !== null &&
                    OdometerZeroFilterValue.length
                    : rows !== null && includeZeroOdometerRows.length)
              }
            />
            <div className="action-btn">
              <div>
                <input
                  type="checkbox"
                  onChange={(e) => includeZeroOdometer(e)}
                />{" "}
                Include zeros
              </div>
              <button onClick={downloadFile}>{t("Download")}</button>
            </div>
          </div>
        </ChartRow>

        {/* Chart of amp hours*/}
        {(avlCarCtrlTypes.allCars || avlCarCtrlTypes.onlyLIN) && <ChartRow>
          <div onMouseLeave={handleChartsMouseLeave}>
            <AmpHoursChart
              data={getCarUsageDetailState}
              includeZeros={!AmpHoursZeroFilter}
              onRefresh={handleAMPHoursChartRefresh}
              onSeriesClick={(e) => openDataModal(e)}
              onSeriesHover={handleUsageChartHover}
            />
          </div>
          <div>
            <div className="heading">
              <div>
                {t("Average")}:{" "}
                {AmpHoursZeroFilter
                  ? getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageAmpHoursDetails?.Average
                  : getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageAmpHoursDetailsIncludesZero
                    ?.Average}{" "}
              </div>
              <div>
                {t("Range")}:{" "}
                {AmpHoursZeroFilter
                  ? getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageAmpHoursDetails?.RangeLow
                  : getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageAmpHoursDetailsIncludesZero
                    ?.RangeLow}{" "}
                -{" "}
                {AmpHoursZeroFilter
                  ? getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageAmpHoursDetails?.RangeHigh
                  : getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageAmpHoursDetailsIncludesZero
                    ?.RangeHigh}{" "}
              </div>
              <div>{t("Cars_outside_range")}</div>
            </div>

            <DataGrid
              onRowClick={(e) => openDataModal(e)}
              rows={
                AmpHoursZeroFilter
                  ? AmpHoursZeroFilterValue !== null && AmpHoursZeroFilterValue
                  : rows !== null && includeZeroAMPHoursRows
              }
              columns={[
                {
                  field: "CarNumber",
                  headerName: t("car"),
                  width: 180,
                  sortable: true,
                },
                {
                  field: "AmpHours",
                  headerName: t("Amp_Hours"),
                  width: 180,
                  sortable: true,
                },
              ]}
              pageSize={
                (AmpHoursZeroFilter
                  ? AmpHoursZeroFilterValue !== null &&
                  AmpHoursZeroFilterValue.length
                  : rows !== null && includeZeroAMPHoursRows.length) > 100 ? 100 : (AmpHoursZeroFilter
                    ? AmpHoursZeroFilterValue !== null &&
                    AmpHoursZeroFilterValue.length
                    : rows !== null && includeZeroAMPHoursRows.length)
              }
            />
            <div className="action-btn">
              <div>
                <input
                  type="checkbox"
                  onChange={(e) => includeZeroAmpHours(e)}
                />{" "}
                Include zeros
              </div>
              <button onClick={downloadFile}>{t("Download")}</button>
            </div>
          </div>
        </ChartRow>}

        {/* Chart of AH per Mile */}
        {(avlCarCtrlTypes.allCars || avlCarCtrlTypes.onlyLIN) && <ChartRow>
          <div onMouseLeave={handleChartsMouseLeave}>
            {getCarUsageDetailState &&
              getCarUsageDetailState !== null &&
              getCarUsageDetailState !== undefined &&
              getCarUsageDetailState?.AverageAmpHoursPerMileDetails !== null ? (
              <Chart
                onRefresh={handleAMPHoursPerMilesChartRefresh}
                onSeriesClick={(e) => openDataModal(e)}
                onSeriesHover={handleUsageChartHover}
              >
                <ChartArea background="#fff" margin={0} />
                <ChartLegend visible={false} />
                <ChartTitle text={t("AH_per_Mile")} font="14pt sans-serif" />
                <ChartTooltip
                  border={{ color: "white" }}
                  background="transparent"
                  color="white"
                  shared={true}
                  render={sharedAHPerMileTooltipRender}
                  visible={true}
                />
                <ChartSeriesDefaults type="column" line={{ width: 1 }} />
                <ChartCategoryAxis>
                  <ChartCategoryAxisItem
                    axisCrossingValue={0}
                    minorTicks={{ visible: false }}
                    labels={{ visible: false }}
                    field="CarNumber"
                  />
                </ChartCategoryAxis>
                <ChartValueAxis>
                  <ChartValueAxisItem
                    axisCrossingValue={0}
                    labels={{
                      color: "black",
                      format: "{0}",
                    }}
                    plotBands={[
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageAmpHoursPerMileDetails
                            ?.RangeHigh,
                        to: 1000000,
                        color: "red",
                        opacity: 0.1,
                      },
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageAmpHoursPerMileDetails
                            ?.RangeLow,
                        to: -1000000,
                        color: "red",
                        opacity: 0.1,
                      },
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageAmpHoursPerMileDetails
                            ?.Average,
                        to:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageAmpHoursPerMileDetails
                            ?.RangeHigh,
                        color: "green",
                        opacity: 0.2,
                      },
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageAmpHoursPerMileDetails
                            ?.Average,
                        to:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageAmpHoursPerMileDetails
                            ?.RangeLow,
                        color: "green",
                        opacity: 0.2,
                      },
                    ]}
                    min={ampHoursPerMileAxisMinMax.Min}
                    max={ampHoursPerMileAxisMinMax.Max}
                    minorTicks={{ visible: false }}
                  />
                </ChartValueAxis>
                <ChartSeries>
                  <ChartSeriesItem
                    gap={0}
                    line={1}
                    field="AmpHoursPerMile"
                    name="AmpHoursPerMile"
                    color={(e) => handleAmpHoursPerMileColor(e)}
                    data={
                      AHPerMilesZeroFilter
                        ? aHPerMileZeroFilterData !== undefined &&
                        aHPerMileZeroFilterData.sort(
                          (a, b) => a.AmpHoursPerMile - b.AmpHoursPerMile
                        )
                        : ampHoursData !== undefined &&
                        ampHoursData.filter((item) => item.AmpHoursPerMile !== undefined && item.AmpHoursPerMile !== null).sort(
                          (a, b) => a.AmpHoursPerMile - b.AmpHoursPerMile
                        )
                    }
                  />
                  <ChartSeriesItem
                    type="line"
                    style="smooth"
                    name="Average"
                    color="black"
                    markers={{
                      visible: false,
                    }}
                  />
                </ChartSeries>
              </Chart>
            ) : (
              <>
                <strong>{t("AH_per_Mile")}</strong>
                <br />
                {t("No_data")}
              </>
            )}
          </div>
          <div>
            <div className="heading">
              <div>
                {t("Average")}:{" "}
                {AHPerMilesZeroFilter
                  ? getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageAmpHoursPerMileDetails
                    ?.Average
                  : getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState
                    ?.AverageAmpHoursPerMileDetailsIncludesZero?.Average}{" "}
              </div>
              <div>
                {t("Range")}:{" "}
                {AHPerMilesZeroFilter
                  ? getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageAmpHoursPerMileDetails
                    ?.RangeLow
                  : getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState
                    ?.AverageAmpHoursPerMileDetailsIncludesZero
                    ?.RangeLow}{" "}
                -{" "}
                {AHPerMilesZeroFilter
                  ? getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageAmpHoursPerMileDetails
                    ?.RangeHigh
                  : getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState
                    ?.AverageAmpHoursPerMileDetailsIncludesZero
                    ?.RangeHigh}{" "}
              </div>
              <div>{t("Cars_outside_range")}</div>
            </div>
            <DataGrid
              onRowClick={(e) => openDataModal(e)}
              rows={
                AHPerMilesZeroFilter
                  ? AHPerMilesZeroFilterValue !== null &&
                  AHPerMilesZeroFilterValue
                  : rows !== null && includeZeroAHPerMilesRows
              }
              columns={[
                {
                  field: "CarNumber",
                  headerName: t("car"),
                  width: 180,
                  sortable: true,
                },
                {
                  field: "AmpHoursPerMile",
                  headerName: t("AH_Mile"),
                  width: 180,
                  sortable: true,
                },
              ]}
              pageSize={
                (AHPerMilesZeroFilter
                  ? AHPerMilesZeroFilterValue !== null &&
                  AHPerMilesZeroFilterValue.length
                  : rows !== null && includeZeroAHPerMilesRows.length) > 100 ? 100 : (AHPerMilesZeroFilter
                    ? AHPerMilesZeroFilterValue !== null &&
                    AHPerMilesZeroFilterValue.length
                    : rows !== null && includeZeroAHPerMilesRows.length)
              }
            />

            <div className="action-btn">
              <div>
                <input
                  type="checkbox"
                  onChange={(e) => includeZeroAHPerMiles(e)}
                />{" "}
                Include zeros
              </div>
              <button onClick={downloadFile}>{t("Download")}</button>
            </div>
          </div>
        </ChartRow>}

        {/* Chart of Round and Hole */}
        {/* Changes needs to be applied here */}
        <ChartRow>
          <div onMouseLeave={handleChartsMouseLeave}>
            {(getRoundsByCarDetailState &&
              getRoundsByCarDetailState !== null &&
              getRoundsByCarDetailState !== undefined &&
              getRoundsByCarDetailState?.AverageHoleDetails !== null) ||
              (getRoundsByCarDetailState &&
                getRoundsByCarDetailState !== null &&
                getRoundsByCarDetailState !== undefined &&
                getRoundsByCarDetailState?.AverageRoundDetails !== null) ? (
              <Chart
                onRefresh={handleRoundHoleChartRefresh}
                onSeriesClick={(e) => openDataModal(e)}
                onSeriesHover={handleUsageChartHover}
              >
                <ChartArea background="#fff" margin={0} />
                <ChartLegend visible={false} />
                <ChartTitle
                  text={roundStateGlobal.get() ? t("Rounds") : t("Holes")}
                  font="14pt sans-serif"
                />
                <ChartTooltip
                  border={{ color: "transparent" }}
                  background="transparent"
                  color="white"
                  shared={true}
                  render={sharedRoundTooltipRender}
                  visible={true}
                />
                <ChartSeriesDefaults type="column" line={{ width: 1 }} />
                <ChartCategoryAxis>
                  <ChartCategoryAxisItem
                    axisCrossingValue={0}
                    minorTicks={{ visible: false }}
                    labels={{ visible: false }}
                    field="CarNumber"
                  />
                </ChartCategoryAxis>
                <ChartValueAxis>
                  <ChartValueAxisItem
                    axisCrossingValue={0}
                    labels={{
                      color: "black",
                      format: "{0}",
                    }}
                    plotBands={[
                      {
                        from: roundsBandHigh,
                        to: 1000000,
                        color: "red",
                        opacity: 0.1,
                      },
                      {
                        from: roundsBandLow,
                        to: -1000000,
                        color: "red",
                        opacity: 0.1,
                      },
                      {
                        from: roundsBandAvg,
                        to: roundsBandHigh,
                        color: "green",
                        opacity: 0.2,
                      },
                      {
                        from: roundsBandAvg,
                        to: roundsBandLow,
                        color: "green",
                        opacity: 0.2,
                      },
                    ]}
                    min={roundsMin}
                    max={roundsMax}
                    minorTicks={{ visible: false }}
                  />
                </ChartValueAxis>
                <ChartSeries>
                  <ChartSeriesItem
                    gap={0}
                    line={1}
                    field={roundStateGlobal.get() ? "Rounds" : "Holes"}
                    name={roundStateGlobal.get() ? "Rounds" : "Holes"}
                    color={(e) => handleRoundsColor(e)}
                    data={
                      roundStateGlobal.get()
                        ? GetRoundsByCarTable &&
                        GetRoundsByCarTable !== undefined &&
                        GetRoundsByCarTable.sort(
                          (a, b) => a.Rounds - b.Rounds
                        )
                        : GetRoundsByCarTable &&
                        GetRoundsByCarTable !== undefined &&
                        GetRoundsByCarTable.sort((a, b) => a.Holes - b.Holes)
                    }
                  />

                  <ChartSeriesItem
                    type="line"
                    style="smooth"
                    name="Average"
                    color="black"
                    markers={{
                      type: "circle",
                      visible: false,
                      rotation: 0,
                      size: 5,
                      background: "black",
                      border: "black",
                      borderRadius: 2,
                    }}
                   
                  />
                </ChartSeries>
              </Chart>
            ) : roundStateGlobal.get() ? (
              <>
                <strong>{t("Round")}</strong>
                <br />
                {t("No_data")}
              </>
            ) : (
              <>
                <strong>Holes</strong>
                <br />
                {t("No_data")}
              </>
            )}
          </div>
          <div>
            <div className="heading">
              <div>
                {t("Average")}:{" "}
                {roundStateGlobal.get()
                  ? getRoundsByCarDetailState &&
                  getRoundsByCarDetailState?.AverageRoundDetails?.Average
                  : getRoundsByCarDetailState &&
                  getRoundsByCarDetailState?.AverageHoleDetails?.Average}{" "}
              </div>
              <div>
                {t("Range")}: {rangeLowRounds !== 0 && rangeLowRounds}-{" "}
                {rangeHighRounds !== 0 && rangeHighRounds}
              </div>
              <div>{t("Cars_outside_range")}</div>
            </div>
            {roundStateGlobal.get() ? ((filteredRangeData !== undefined && filteredRangeData != null) ?
              <DataGrid
                rows={filteredRangeData !== null && filteredRangeData}
                onRowClick={(e) => openDataModal(e)}
                columns={[
                  {
                    field: "Car",
                    headerName: "Car",
                    width: 180,
                    sortable: true,
                  },
                  {
                    field: "Rounds",
                    headerName: "Rounds",
                    width: 180,
                    sortable: true,
                  },
                ]}
                pageSize={filteredRangeData.length > 100 ? 100 : filteredRangeData.length}
              /> : <></>
            ) : ((avarageRoundDataValue !== undefined && avarageRoundDataValue != null) ?
              <DataGrid
                rows={avarageRoundDataValue !== null && avarageRoundDataValue}
                onRowClick={(e) => openDataModal(e)}
                columns={[
                  {
                    field: "Car",
                    headerName: t("car"),
                    width: 180,
                    sortable: true,
                  },
                  {
                    field: "Holes",
                    headerName: t("Holes"),
                    width: 180,
                    sortable: true,
                  },
                ]}
                pageSize={avarageRoundDataValue.length > 100 ? 100 : avarageRoundDataValue.length}
              />
              : <></>)}
          </div>
        </ChartRow>

        {TempCarObj !== null && TempCarObj !== undefined ? (
          <>
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <CarDetails
                  carInformation={TempCarObj}
                  handleClick={handleClick}
                  paceString={paceString}
                />
              </Box>
            </Modal>
            <Modal
              open={isLoading.get()}
              onClose={handleClose2}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style2}>
                <MsgToSelectedCarsCmp cancelClick={handleClose2} />
              </Box>
            </Modal>
          </>
        ) : (
          ""
        )}
        <Modal
          open={openCarNotFound}
          onClose={() => setOpenCarNotFound(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style3}>
            <PopUpContainer>
              <h4>{`Car ${clickedCarNumber} not found`}</h4>
              <div className="action-btn">
                <button
                  className="primary"
                  onClick={() => setOpenCarNotFound(false)}
                >
                  {t("Ok")}
                </button>
              </div>
            </PopUpContainer>
          </Box>
        </Modal>
        <SortingHeader ref={filterH}>
          <div className="date-range-wrapper">
            <div className="label-wrapper">
              <label name="start">{t("Start")}</label>
              {/* <input value={startDate} onChange={(e) => startDateChange(e)} type="date" /> */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  name="start"
                  value={startDate}
                  inputFormat="DD-MMM-YYYY"
                  label=""
                  onChange={(newValue) => setStartDate(newValue)}
                  renderInput={(params) => <TextField {...params} />}
                  components={{
                    ActionBar: (props) => (
                      <TodayDateActionBar
                        onToday={() => {
                          const today = moment().startOf("day");
                          setStartDate(today);
                          props.onAccept?.();
                          props.onClose?.();
                        }}
                      />
                    ),
                  }}
                />
              </LocalizationProvider>
            </div>
            <div className="label-wrapper">
              <label name="End">{t("End")}</label>
              {/* <input value={endDate} onChange={(e) => endDateChange(e)} type="date" /> */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  name="End"
                  value={endDate}
                  inputFormat="DD-MMM-YYYY"
                  label=""
                  onChange={(newValue) => setEndDate(newValue)}
                  renderInput={(params) => <TextField {...params} />}
                  components={{
                    ActionBar: (props) => (
                      <TodayDateActionBar
                        onToday={() => {
                          const today = moment().startOf("day");
                          setEndDate(today);
                          props.onAccept?.();
                          props.onClose?.();
                        }}
                      />
                    ),
                  }}
                />
              </LocalizationProvider>
            </div>
          </div>
          <div className="btn-header-wrapper">
            <CircleBtn
              onClick={() => {
                holeStateGlobal.set(false);
                roundStateGlobal.set(true);
              }}
              style={roundStateGlobal.get() ? activeBtn : null}
            >
              {t("Rounds")}
            </CircleBtn>
            <CircleBtn
              onClick={() => {
                holeStateGlobal.set(true);
                roundStateGlobal.set(false);
              }}
              style={holeStateGlobal.get() ? activeBtn : null}
            >
              Holes
            </CircleBtn>

            <CircleBtn
              style={MtdState ? activeBtn : null}
              onClick={showMonthlyData}
            >
              MTD
            </CircleBtn>
            <CircleBtn
              style={QtdState ? activeBtn : null}
              onClick={showQuaterlyData}
            >
              QTD
            </CircleBtn>
            <CircleBtn
              style={YTDState ? activeBtn : null}
              onClick={showYearlyData}
            >
              YTD
            </CircleBtn>
            <CircleBtn onClick={RounddownloadFile}>{t("Download")}</CircleBtn>
            <CircleBtn onClick={refreshFunc}>{t("Refresh")}</CircleBtn>
          </div>
        </SortingHeader>
      </UsageContainer>
    </Wrapper>
  );
});

export default UsageReport;
